import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReorder: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconReorder"><Path d="M6.5 3C4.567 3 3 4.567 3 6.5C3 8.433 4.567 10 6.5 10C8.433 10 10 8.433 10 6.5C10 4.567 8.433 3 6.5 3Z" fill="currentColor"/><Path d="M16.6697 4.27822L15.6376 3.18972L12.425 6.2357L15.5 9.31066L16.5607 8.25L15.3107 7H19.5V17H13V18.5H21V5.5H15.3811L16.6697 4.27822Z" fill="currentColor"/><Path d="M6.5 14C4.567 14 3 15.567 3 17.5C3 19.433 4.567 21 6.5 21C8.433 21 10 19.433 10 17.5C10 15.567 8.433 14 6.5 14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconReorder;
